// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { type ReactElement, type ReactNode } from "react";

import { FormattedMessage } from "react-intl";

export const NonLensPlusRemaining = (props: { remaining: number }): ReactElement => (
    <FormattedMessage
        id="apps.shared.components.submissionQuota.nonLensPlusRemaining"
        description="Non lens plus remaining."
        defaultMessage="{remaining, plural, one {# Non-Lens+ submission left} other {# Non-Lens+ submissions left}}"
        values={props}
    />
);
NonLensPlusRemaining.displayName = "NonLensPlusRemaining";

export const LensPlusRemaining = (props: { remaining: number }): ReactElement => (
    <FormattedMessage
        id="apps.shared.components.submissionQuota.lensPlusRemaining"
        description="Lens plus remaining."
        defaultMessage="{remaining, plural, one {# Lens+ submission left} other {# Lens+ submissions left}}"
        values={props}
    />
);
LensPlusRemaining.displayName = "LensPlusRemaining";

export const NonLensPlusUnavailable = (): ReactElement => (
    <FormattedMessage
        id="apps.shared.components.submissionQuota.nonLensPlusUnavailable"
        description="Non lens plus unavailable."
        defaultMessage="No Non-Lens+ submissions left"
    />
);
NonLensPlusUnavailable.displayName = "NonLensPlusUnavailable";

export const LensPlusUnavailable = (): ReactElement => (
    <FormattedMessage
        id="apps.shared.components.submissionQuota.lensPlusUnavailable"
        description="Lens plus unavailable."
        defaultMessage="No Lens+ submissions left"
    />
);
LensPlusUnavailable.displayName = "LensPlusUnavailable";

export const RunningLow = (): ReactElement => (
    <FormattedMessage
        id="apps.shared.components.submissionQuota.runningLow"
        description="Running low."
        defaultMessage="Running low"
    />
);
RunningLow.displayName = "RunningLow";

export const AlmostAtLimit = (): ReactElement => (
    <FormattedMessage
        id="apps.shared.components.submissionQuota.almostAtLimit"
        description="Almost at limit."
        defaultMessage="Almost at your limit"
    />
);
AlmostAtLimit.displayName = "AlmostAtLimit";

export const NonLensPlusResetsDaily = (): ReactElement => (
    <FormattedMessage
        id="apps.shared.components.submissionQuota.nonLensPlusResetsDaily"
        description='Tooltip line telling a lens creator that their regular (non Lens+) submission allowance refills every day. "Non-Lens+" is a product name and must not be translated.'
        defaultMessage="Non-Lens+ counts reset daily."
    />
);
NonLensPlusResetsDaily.displayName = "NonLensPlusResetsDaily";

export const NonLensPlusResetsMonthly = (): ReactElement => (
    <FormattedMessage
        id="apps.shared.components.submissionQuota.nonLensPlusResetsMonthly"
        description='Tooltip line telling a lens creator that their regular (non Lens+) submission allowance refills every calendar month. "Non-Lens+" is a product name and must not be translated.'
        defaultMessage="Non-Lens+ counts reset monthly."
    />
);
NonLensPlusResetsMonthly.displayName = "NonLensPlusResetsMonthly";

export const LensPlusResetsDaily = (): ReactElement => (
    <FormattedMessage
        id="apps.shared.components.submissionQuota.lensPlusResetsDaily"
        description='Tooltip line telling a lens creator that their Lens+ submission allowance refills every day. "Lens+" is a product name and must not be translated.'
        defaultMessage="Lens+ counts reset daily."
    />
);
LensPlusResetsDaily.displayName = "LensPlusResetsDaily";

export const LensPlusResetsMonthly = (): ReactElement => (
    <FormattedMessage
        id="apps.shared.components.submissionQuota.lensPlusResetsMonthly"
        description='Tooltip line telling a lens creator that their Lens+ submission allowance refills every calendar month. "Lens+" is a product name and must not be translated.'
        defaultMessage="Lens+ counts reset monthly."
    />
);
LensPlusResetsMonthly.displayName = "LensPlusResetsMonthly";

export const NonLensPlusResetsOnSchedule = (): ReactElement => (
    <FormattedMessage
        id="apps.shared.components.submissionQuota.nonLensPlusResetsOnSchedule"
        description='Tooltip line used when the server reports a reset cadence this app version does not recognise, so only the pool can be named. "Non-Lens+" is a product name and must not be translated.'
        defaultMessage="Non-Lens+ counts reset on a recurring schedule."
    />
);
NonLensPlusResetsOnSchedule.displayName = "NonLensPlusResetsOnSchedule";

export const LensPlusResetsOnSchedule = (): ReactElement => (
    <FormattedMessage
        id="apps.shared.components.submissionQuota.lensPlusResetsOnSchedule"
        description='Tooltip line used when the server reports a reset cadence this app version does not recognise, so only the pool can be named. "Lens+" is a product name and must not be translated.'
        defaultMessage="Lens+ counts reset on a recurring schedule."
    />
);
LensPlusResetsOnSchedule.displayName = "LensPlusResetsOnSchedule";

export const AboutSubmissionLimits = (): ReactElement => (
    <FormattedMessage
        id="apps.shared.components.submissionQuota.aboutSubmissionLimits"
        description="About submission limits."
        defaultMessage="About submission limits"
    />
);
AboutSubmissionLimits.displayName = "AboutSubmissionLimits";

export const NextReset = (props: { resetAt: ReactNode }): ReactElement => (
    <FormattedMessage
        id="apps.shared.components.submissionQuota.nextReset"
        description="Next reset."
        defaultMessage="Next reset {resetAt}"
        values={props}
    />
);
NextReset.displayName = "NextReset";

export const GetHigherLimitsWithLensPlus = (): ReactElement => (
    <FormattedMessage
        id="apps.shared.components.submissionQuota.getHigherLimitsWithLensPlus"
        description='Link shown next to a nearly used or exhausted Lens+ submission allowance, sending the creator to the Lens+ subscription page. "Lens+" is a product name and must not be translated.'
        defaultMessage="Get higher limits with Lens+"
    />
);
GetHigherLimitsWithLensPlus.displayName = "GetHigherLimitsWithLensPlus";
